import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "container-article" }
const _hoisted_3 = {
  key: 0,
  class: "row row-eq-height"
}
const _hoisted_4 = { class: "col-12 col-md-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-12 col-md-8" }
const _hoisted_7 = { class: "album-intro-card" }
const _hoisted_8 = { class: "album-title" }
const _hoisted_9 = { class: "style-list" }
const _hoisted_10 = { class: "album-year" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "style-list"
}
const _hoisted_13 = { class: "heart-list" }
const _hoisted_14 = {
  key: 0,
  class: "hot-info-item"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fire text-gray" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "hot-info-item"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-heartfillmtui" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-heartbeat" }, null, -1)
const _hoisted_20 = { class: "container-article" }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = { class: "article-content" }
const _hoisted_24 = { class: "intro-title" }
const _hoisted_25 = { class: "score" }
const _hoisted_26 = { class: "auther-title" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "hot-info-item"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_30 = {
  key: 2,
  class: "edit-button-holder"
}
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "links" }
const _hoisted_33 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, "评论区", -1)
const _hoisted_35 = { class: "container" }
const _hoisted_36 = { class: "row row-eq-height" }
const _hoisted_37 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "相关文章", -1)
const _hoisted_39 = { class: "bg-white row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StyleTag = _resolveComponent("StyleTag")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_CommentList = _resolveComponent("CommentList")!
  const _component_ArticleListItem = _resolveComponent("ArticleListItem")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.article)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.article.album_data.primary_img,
                class: "img-fluid img-full"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.album_data.artists, (artist) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: artist._id,
                      to: { path: '/meta/artist/' + artist._id },
                      class: "artist-name"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(artist.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  _createVNode(_component_router_link, {
                    to: { path: '/meta/album/' + _ctx.article.album_data._id },
                    class: "album-name"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.article.album_data.title), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, "[ " + _toDisplayString(_ctx.article.album_data.year) + " ]", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.album_data.online_links, (link, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "link-outside link-online"
                    }, [
                      _createElementVNode("a", {
                        href: link.url,
                        target: "_blank"
                      }, _toDisplayString(_ctx.online_link_name[index]), 9, _hoisted_11)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.album_data.styles, (style) => {
                    return (_openBlock(), _createBlock(_component_StyleTag, {
                      key: style._id,
                      genre: style,
                      full: 0
                    }, null, 8, ["genre"]))
                  }), 128))
                ]),
                (_ctx.article.album_data.relate_styles.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.album_data.relate_styles, (style) => {
                        return (_openBlock(), _createBlock(_component_StyleTag, {
                          key: style._id,
                          genre: style,
                          full: 0
                        }, null, 8, ["genre"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.article.album_data.hot_index > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.article.album_data.hot_index), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.article.album_data.counter_view > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.article.album_data.counter_view), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: _normalizeClass(["hot-info-item", { active: _ctx.now_heart == 1 }]),
                    href: "javascript:void(0)",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doHeart(1)))
                  }, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.article.album_data.counter_heart_1), 1)
                  ], 2),
                  _createElementVNode("a", {
                    class: _normalizeClass(["hot-info-item", { active: _ctx.now_heart == 2 }]),
                    href: "javascript:void(0)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doHeart(2)))
                  }, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.article.album_data.counter_heart_2), 1)
                  ], 2)
                ])), [
                  [_directive_loading, _ctx.heart_loading]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
      (_ctx.article)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.article.score), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.article.title), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_UserTag, {
                    user: _ctx.article.user_created,
                    full: 1
                  }, null, 8, ["user"]),
                  _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
                  (_ctx.article.ts_updated !== _ctx.article.ts_published)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" ] "),
                  (_ctx.article.counter_view > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                        _hoisted_29,
                        _createTextVNode(" " + _toDisplayString(_ctx.article.counter_view), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userInfo.userId == _ctx.article.user_created._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-success",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goEditArticle()))
                        }, " 编辑 ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "info-holder",
                  innerHTML: _ctx.markdown.render(_ctx.article.content)
                }, null, 8, _hoisted_31),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: { path: '/rank/rank/' + _ctx.article.main_rank_id._id },
                    class: "artit-name"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" [全部榜单] ")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: { path: '/rank/version/' + _ctx.article.main_version_id._id }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" [本榜单] ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]),
            (_ctx.userInfo.userId && _ctx.article?.album_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_CommentList, {
                    "target-type": "ITEM_ALBUM",
                    "target-id": _ctx.article._id,
                    "comment-info": {
                            rank_id: _ctx.article.main_rank_id._id,
                            version_id: _ctx.article.main_version_id._id,
                            artist_id: _ctx.article.album_data.main_artist._id,
                            album_id: _ctx.article.album_data._id,
                            version_item: _ctx.article._id,
                        }
                  }, null, 8, ["target-id", "comment-info"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        (_ctx.articles.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article_info) => {
                  return (_openBlock(), _createBlock(_component_ArticleListItem, {
                    key: article_info._id,
                    class: "col-md-4 col-sm-6 col-xs-12 col-12",
                    article: article_info,
                    full: 2,
                    position: "related"
                  }, null, 8, ["article"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ])), [
    [_directive_wechat_title, _ctx.article ? _ctx.article.title + ' - ' + _ctx.article.album_data.title : undefined]
  ])
}